export default "__VITE_ASSET__DJUTgTVk__"